module.exports = __webpack_public_path__ + "img/cs4.5552b913.png";